import React from 'react';
import { TablePagination } from '@material-ui/core';

const UITablePagination = ({ ...props }) => (
  <TablePagination
    component="div"
    rowsPerPageOptions={[5, 10, 25, { label: 'Todas', value: -1 }]}
    labelRowsPerPage="Linhas por página"
    labelDisplayedRows={({ from, to, count }) =>
      `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
    }
    backIconButtonProps={{
      'aria-label': 'Página anterior',
    }}
    nextIconButtonProps={{
      'aria-label': 'Próxima página',
    }}
    SelectProps={{
      inputProps: { 'aria-label': 'Linhas por página' },
      native: true,
    }}
    {...props}
  />
);

export default UITablePagination;
